<template>
  <input-dropdown :value="displayLanguage" @input="input" @change="change" :label="$t('authenticationLanguageLabel')"
    :options="options" v-bind="$attrs" />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import i18n from '@/configured/vue-i18n';
import { craftSiteHandleToAppLocale } from '@/configured/languages/config';
import InputDropdown from './InputDropdown.vue';

export default {
  name: 'InputLanguageDropdown',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapState(i18n.store.namespace, [
      'availableLanguages'
    ]),
    /** Align parent value with option values (maps legacy EU Spanish handles to `es-ES`). */
    displayLanguage() {
      return craftSiteHandleToAppLocale(this.value);
    },
    options() {
      return [...this.availableLanguages]
        .sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' }))
        .map(language => ({
          id: language.id,
          label: language.name,
          // LANGUAGE_CONFIG / i18n key — use localeToCraftSiteHandle() for API site segment
          value: craftSiteHandleToAppLocale(language.handle),
        }));
    }
  },
  methods: {
    ...mapActions(i18n.store.namespace, [
      'getAvailableLanguages',
    ]),
    change(value) {
      this.$emit('change', value);
    },
    input(value) {
      this.$emit('input', value);
    },
  },
  beforeMount() {
    this.getAvailableLanguages();
  },
  components: {
    InputDropdown,
  }
}
</script>
